// extracted by mini-css-extract-plugin
export default {"tab-panel":"GHguvPU5S3VP6jelIKNqgA=="};